/* eslint-disable @typescript-eslint/default-param-last */
import { EUserRole, IAuthActionType } from "@/types/auth.types";
import {
  CANDIDATE_JOINED,
  END_INTERVIEW_FOR_ALL,
  GET_USER_STATUS,
  LEAVE_INTERVIEW,
  SET_OTP_ERROR,
  SET_OTP_LOADING,
  START_INTERVIEW,
} from "@/constants/ActionTypes";
import initialState from "@/store/initialState";

const authReducer = (state = initialState.auth, action: IAuthActionType) => {
  switch (action.type) {
    case `${GET_USER_STATUS}_SUCCESS`:
      return {
        ...state,
        userIdentityData: {
          ...action.payload,
          isInterviewer: action.payload.role === EUserRole.INTERVIEWER,
          isCandidate: action.payload.role === EUserRole.CANDIDATE,
        },
      };
    case `${SET_OTP_LOADING}_SUCCESS`:
      return { ...state, otp: { ...state.otp, otpLoading: true } };
    case `${SET_OTP_LOADING}_COMPLETED`:
      return { ...state, otp: { ...state.otp, otpLoading: false } };
    case `${SET_OTP_ERROR}_SUCCESS`:
      return {
        ...state,
        otp: { ...state.otp, otpError: action.payload.message },
      };
    case `${START_INTERVIEW}_SUCCESS`:
      return {
        ...state,
        userIdentityData: { ...state.userIdentityData, ...action.payload },
      };
    case CANDIDATE_JOINED:
      return {
        ...state,
        userIdentityData: {
          ...state.userIdentityData,
          ...action.payload,
          is_joined: true,
        },
      };
    case `${LEAVE_INTERVIEW}_SUCCESS`:
    case `${END_INTERVIEW_FOR_ALL}_SUCCESS`:
      return {
        ...state,
        userIdentityData: { ...state.userIdentityData, ...action.payload },
      };
    default:
      return state;
  }
};

export default authReducer;
